import { render, staticRenderFns } from "./ProfileCompletionForm.vue?vue&type=template&id=06067e5c"
import script from "./ProfileCompletionForm.vue?vue&type=script&lang=js"
export * from "./ProfileCompletionForm.vue?vue&type=script&lang=js"
import style0 from "./ProfileCompletionForm.vue?vue&type=style&index=0&id=06067e5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports